"use client";
import { createContext, useContext } from "react";
export const AuthenticationContext = createContext(null);
export const useAuthenticationContext = () => {
    const context = useContext(AuthenticationContext);
    if (context === null) {
        throw new Error("Please provide an authentication context.");
    }
    return context;
};
//# sourceMappingURL=AuthenticationContext.js.map